export default "__VITE_ASSET__DSBKSKK2__"